(function () {
  'use strict';

  angular.module('app').component('bookingPage', bookingDetailComponent());

  function bookingDetailComponent() {
    return {
      bindings: {},
      controller: BookingDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/booking-page.component.html',
    };
  }

  BookingDetailCtrl.$inject = ['$location', '$routeParams', 'AbilityService', 'BookingService'];

  function BookingDetailCtrl($location, $routeParams, AbilityService, BookingService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_booking_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        //Edit
        vm.loadingItem = true;
        BookingService.getBooking(itemId).then(function (data) {
          vm.item = data;
          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/bookings/${item.id}`).search({ mode: 'edit' });
    }

    function onCanceledItem() {
      if ($routeParams.type === 'report') {
        $location.path('/prepayment_reports');
      } else {
        $location.path('/bookings');
      }
    }
  }
})();
